import { Tag, TagResource } from './Tag';

export const transformToTag = (resource: TagResource): Tag => ({
    id: resource.id.toString(),
    name: resource.tag,
    slug: resource.tag,
});
